import { useState } from 'react';
import { BiPencil, BiTrash } from 'react-icons/bi';
import { DefaultButton } from '../../../../components/Button/Button';
import { BudgetCreatingImage } from './BudgetCreatingImage';
import { ImageZoom } from '../../../../containers/OrderServiceBudget/TabsContainer/ImageZoom/image';
import { BUDGET_TABS } from '../../utils/enum';

export const BudgetImageChecklist = (props) => {
  const { budget, onChange, values } = props;
  const [isCreating, setIsCreating] = useState(false);
  const [editingIndex, setEditingIndex] = useState(0);

  if (budget !== BUDGET_TABS.IMAGE_CHECKLIST) {
    return;
  }

  const handleDelete = (imageId) => {
    const updatedImages = values.image_checklist?.filter(
      (item) => item?.id !== imageId
    );

    onChange('image_checklist', updatedImages || []);
  };

  return (
    <div style={{ paddingTop: '20px' }}>
      <div className="os-entry-checklist-title-container">
        <h5 className="os-entry-checklist-title">Registro por imagem</h5>
        <DefaultButton
          className="modal-footer-button"
          label={'+ Adicionar imagem'}
          onClick={() => {
            setIsCreating(true);
            setEditingIndex(null);
          }}
        />
      </div>

      <div>
        {isCreating && (
          <BudgetCreatingImage
            setEditingIndex={setEditingIndex}
            editingIndex={editingIndex}
            values={values}
            onChange={onChange}
            setIsOpen={setIsCreating}
            isOpen={isCreating}
          />
        )}
        <div className="os-entry-checklist-image-mapper">
          {!values?.image_checklist?.length && (
            <span style={{ color: 'gray' }}>
              Nenhum registro por imagem foi feito até o momento
            </span>
          )}

          {values?.image_checklist?.map((image, index) => {
            return (
              <div
                key={`${image?.image}-${index}`}
                className="os-entry-checklist-image-container"
              >
                <div style={{ display: 'flex', gap: 10 }}>
                  <div>
                    <ImageZoom image={image?.image} />
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      width: '100%',
                      marginRight: 6,
                      marginTop: 6,
                    }}
                  >
                    <div
                      style={{ width: '100%' }}
                      className="os-entry-checklist-image-description"
                    >
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          width: '100%',
                        }}
                      >
                        <span style={{ color: 'white' }}>
                          <span style={{ color: 'gray', fontWeight: 'bold' }}>
                            Peça:{' '}
                          </span>
                          {image?.piece?.label}
                        </span>

                        <div className="os-entry-checklist-image-actions">
                          <BiPencil
                            style={{ marginRight: 10 }}
                            onClick={() => {
                              setEditingIndex(index);
                              setIsCreating(true);
                            }}
                            className="os-entry-checklist-list-icon-style"
                          />

                          <BiTrash
                            onClick={() => handleDelete(image?.id)}
                            className="os-entry-checklist-list-icon-style"
                          />
                        </div>
                      </div>

                      <span style={{ color: 'white' }}>
                        <span style={{ color: 'gray', fontWeight: 'bold' }}>
                          Descrição:{' '}
                        </span>
                        {image?.description?.label}
                      </span>

                      <span style={{ color: 'white' }}>
                        <span style={{ color: 'gray', fontWeight: 'bold' }}>
                          Observações:{' '}
                        </span>
                        <span className="truncate">{image?.observation}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
